import { render } from "./Loading.vue?vue&type=template&id=71d8d171&scoped=true"
const script = {}

import "./Loading.vue?vue&type=style&index=0&id=71d8d171&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-71d8d171"

export default script